export function safeTruncate(text, maxLength = 100, options = {}) {
  try {
    const {
      ellipsis = "…",
      preserveWords = true,
      trim = true,
    } = options;

    if (typeof text !== "string") return "";
    if (!maxLength || maxLength <= 0) return "";

    if (text.length <= maxLength) {
      return trim ? text.trim() : text;
    }

    let truncated = text.slice(0, maxLength);

    if (preserveWords) {
      const lastSpace = truncated.lastIndexOf(" ");
      if (lastSpace > 0) truncated = truncated.slice(0, lastSpace);
    }

    if (trim) truncated = truncated.trim();

    return truncated + ellipsis;
  } catch (e) {
    return ""; // never break the UI
  }
}
